import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { BaseBasicDialog } from '@appshared';

@Component({
  selector: 'app-reject-request-dialog',
  templateUrl: './reject-request-dialog.component.html',
  styleUrls: ['./reject-request-dialog.component.scss'],
})
export class RejectRequestDialogComponent extends BaseBasicDialog {
  reason: string;

  constructor(
    public dialogRef: MatDialogRef<RejectRequestDialogComponent>,
    protected _fuseTranslationLoaderService: FuseTranslationLoaderService,
    protected _fuseProgressBarService: FuseProgressBarService
  ) {
    super(dialogRef, _fuseTranslationLoaderService, _fuseProgressBarService);
  }
}
